import React from "react";

export const SEARCH_MARK_CLASS = "preview-search-mark";
export const SEARCH_MARK_ACTIVE_CLASS = "preview-search-mark-active";

export function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function countMatches(text: string, query: string): number {
  if (!query || !text) return 0;
  const re = new RegExp(escapeRegex(query), "gi");
  const matched = text.match(re);
  return matched ? matched.length : 0;
}

interface HighlightedTextProps {
  text: string;
  query: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  query,
}) => {
  if (!query) return <>{text}</>;
  const re = new RegExp(`(${escapeRegex(query)})`, "gi");
  const parts = text.split(re);
  return (
    <>
      {parts.map((part, idx) =>
        idx % 2 === 1 ? (
          <mark key={idx} className={SEARCH_MARK_CLASS}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={idx}>{part}</React.Fragment>
        ),
      )}
    </>
  );
};
